import { AtlasFieldText, AtlasOptions, AtlasOptionsGroup, AtlasOptionsItem, AtlasSearchDropdown } from "atlas-ds";
import { ChangeEvent, useEffect, useState } from "react";

interface DropdownProps {
    name: string
    label: string
    options: AtlasOptionsItem[] | AtlasOptionsGroup[]
    loading?: boolean
    onClear?: () => void
    icon?: string
    recherche?: string
    disabled?: boolean
    tooltipContent?: string
}

export function Dropdown(props: DropdownProps) {
    const [recherche, setRecherche] = useState(props.recherche)
    const [hasSelectedOption, setHasSelectedOption] = useState(false)

    const optionMatchesSearch = (option: AtlasOptionsItem) => recherche
        && typeof option.content === "string"
        && option.content.toLowerCase().includes(recherche.toLowerCase())

    const options = !hasSelectedOption && recherche
        ? (props.options[0] && "options" in props.options[0])
            ? (props.options as AtlasOptionsGroup[]).map(group => ({
                ...group,
                options: group.options.filter(optionMatchesSearch)
            })).filter(group => group.options.length > 0)
            : (props.options as AtlasOptionsItem[]).filter(optionMatchesSearch)
        : props.options

    useEffect(() => {
        setSelectedAsRecherche()
    }, [props.options])

    const setSelectedAsRecherche = () => {
        const options = (props.options[0] && "options" in props.options[0])
            ? props.options.flatMap(group => (group as AtlasOptionsGroup).options)
            : props.options

        const selectedOption = (options.find((option: any) => option.selected) as any)?.content

        setRecherche(selectedOption ?? props.recherche ?? "")

        if (selectedOption) {
            setHasSelectedOption(true)
        }
    }

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        setRecherche(event.target.value)
        setHasSelectedOption(false)
    }

    return <AtlasSearchDropdown
        loading={props.loading}
        resultsCount={options.flatMap(options => "options" in options ? options.options : options).length}
        onBlur={setSelectedAsRecherche}
        input={<AtlasFieldText
            autoComplete="off"
            value={recherche ?? ""}
            name={props.name}
            label={props.label}
            icon={props.icon}
            disabled={props.disabled}
            tooltipContent={props.tooltipContent}
            onChange={onChange}
            onClear={props.onClear}
        />}
    >
        <AtlasOptions ariaLabel={props.label} options={options} />
    </AtlasSearchDropdown>
}
